import React, { useRef, useEffect } from 'react';

function heroBackground(ctx, w, h){
  function mul32(a){return function(){a|=0;a=a+0x6D2B79F5|0;var t=Math.imul(a^a>>>15,1|a);t=t+Math.imul(t^t>>>7,61|t)^t;return((t^t>>>14)>>>0)/4294967296;};}
  function smooth(t){return t*t*(3-2*t);}
  function makeNoise(seed){var rnd=mul32(seed),G=64,g=new Float32Array(G*G);for(var i=0;i<G*G;i++)g[i]=rnd();
    return function(x,y){x=(x%1+1)%1*G;y=(y%1+1)%1*G;var x0=Math.floor(x),y0=Math.floor(y),fx=smooth(x-x0),fy=smooth(y-y0);var x1=(x0+1)%G,y1=(y0+1)%G;x0=x0%G;y0=y0%G;var a=g[y0*G+x0],b=g[y0*G+x1],c=g[y1*G+x0],d=g[y1*G+x1];var t1=a+(b-a)*fx;return t1+((c+(d-c)*fx)-t1)*fy;};}
  function mix(a,b,t){return [a[0]+(b[0]-a[0])*t,a[1]+(b[1]-a[1])*t,a[2]+(b[2]-a[2])*t];}
  function rgba(c,al){return 'rgba('+(c[0]|0)+','+(c[1]|0)+','+(c[2]|0)+','+al+')';}
  var BLUE=[23,73,135], CYAN=[0,166,218];
  var g=ctx.createLinearGradient(0,0,w,h);
  g.addColorStop(0,'#050D1C'); g.addColorStop(.55,'#07152D'); g.addColorStop(1,'#040A16');
  ctx.fillStyle=g; ctx.fillRect(0,0,w,h);
  var r=ctx.createRadialGradient(w*.72,h*.18,0,w*.72,h*.18,Math.max(w,h)*.75);
  r.addColorStop(0,'rgba(23,73,135,.34)'); r.addColorStop(1,'rgba(23,73,135,0)');
  ctx.fillStyle=r; ctx.fillRect(0,0,w,h);
  var r2=ctx.createRadialGradient(w*.14,h*.9,0,w*.14,h*.9,Math.max(w,h)*.6);
  r2.addColorStop(0,'rgba(0,166,218,.16)'); r2.addColorStop(1,'rgba(0,166,218,0)');
  ctx.fillStyle=r2; ctx.fillRect(0,0,w,h);
  var n=makeNoise(88), bands=Math.round(h/3.1);
  for(var i=0;i<bands;i++){
    var p=i/bands;
    var lit=Math.abs(p-.34)<.16 ? 1-Math.abs(p-.34)/.16 : 0;
    var col=mix(BLUE,CYAN,Math.pow(lit,1.4));
    ctx.strokeStyle=rgba(col,.10+.26*(1-Math.abs(p-.38)*1.5));
    ctx.lineWidth=.6+1.5*(1-Math.abs(p-.38));
    ctx.beginPath();
    for(var x=-10;x<=w+10;x+=Math.max(4,w/260)){
      var k=x/w;
      var amp=h*(.10+.055*n(p*.9,.3));
      var y=h*p+Math.sin(k*3.1+p*5.2)*amp+(n(k*1.25,p*1.35)-.5)*h*.10;
      x===-10?ctx.moveTo(x,y):ctx.lineTo(x,y);
    }
    ctx.stroke();
  }
  var v=ctx.createLinearGradient(0,0,0,h);
  v.addColorStop(0,'rgba(4,10,22,.42)'); v.addColorStop(.5,'rgba(4,10,22,0)'); v.addColorStop(1,'rgba(4,10,22,.55)');
  ctx.fillStyle=v; ctx.fillRect(0,0,w,h);
}

export const HeroCanvas = () => {
  const ref = useRef(null);
  useEffect(() => {
    const canvas = ref.current;
    if (!canvas) return;
    const draw = () => {
      const rect = canvas.getBoundingClientRect();
      const cssW = rect.width, cssH = rect.height;
      if (!cssW || !cssH) return;
      const ratio = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = Math.round(cssW * ratio);
      canvas.height = Math.round(cssH * ratio);
      const ctx = canvas.getContext('2d');
      ctx.setTransform(ratio, 0, 0, ratio, 0, 0);
      heroBackground(ctx, cssW, cssH);
    };
    draw();
    window.addEventListener('resize', draw);
    return () => window.removeEventListener('resize', draw);
  }, []);
  return <canvas ref={ref} aria-hidden="true" className="hero-canvas block absolute top-0 left-0 h-full" />;
};
